import { useAuth, useRequest } from "@onefront/react-sdk";
import { buildHeaders } from "../../../views/common-utils/buildHeaders";
import { useCallback, useState } from "react";

export enum ResponseStatus {
  OK = 200,
  INTERNAL_SERVER_ERROR = 500,
}

interface DataType {
  documentStatus: Record<string, boolean>;
}

export function usePatchRestoreDocumentsFromBin(): {
  data: DataType;
  error: any;
  fetch: (workspaceId: string, payload: string[]) => Promise<ResponseStatus>;
  loading: boolean;
} {
  const [data, setData] = useState<DataType>();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const authData = useAuth();
  const request = useRequest();

  const fetchData = useCallback(
    async (workspaceId: string, payload: string[]) => {
      setLoading(true);

      try {
        const response = await request.fetch({
          headers: buildHeaders({ authData }),
          data: {
            documentIds: payload,
          },
          method: "PATCH",
          lazy: true,
          stateless: true,
          url: `documentsApi://api/v1/documents/restoreFromBin?workspaceId=${workspaceId}`,
        });
        setData(response.data);
        return ResponseStatus.OK;
      } catch (err: any) {
        console.error(err);
        setError(err);
        return ResponseStatus.INTERNAL_SERVER_ERROR;
      } finally {
        setLoading(false);
      }
    },
    [authData, request]
  );

  return {
    data: data,
    error,
    fetch: fetchData,
    loading,
  };
}
